import React from 'react'
import ReCAPTCHA from 'react-google-recaptcha'

const Recaptcha = ({ onChange, invalid, errorMessage }) => {
  const handleChange = /* istanbul ignore next */ token => {
    onChange(token)
  }

  return (
    <div>
      <ReCAPTCHA
        sitekey={
          process.env.REACT_APP_RECAPTCHA_SITE_KEY ||
          '6Leh_PgrAAAAAAhu3ORAcuNnaB4alcPIFBsJciQO'
        }
        size="normal"
        onChange={handleChange}
      />
      {invalid && <p className="text-red-400 mt-0 mb-4">{errorMessage}</p>}
    </div>
  )
}

export default Recaptcha
